// The shape of a member id that came from the legacy estate.
//
// The grammar itself lives in `@galapagos/product-analytics`, the lowest
// package in the `shared -> observability -> product-analytics` chain. It has
// to: the analytics subject guard, the Datadog `usr.id` boundary and the
// ADR-081 leak guards all need the same shape, `@galapagos/shared` already
// depends on product-analytics, and the reverse import would close a cycle.
// This module is the identity-layer name for it, so every consumer that knows
// the grammar as `legacyIdentityIdSchema` (ADR-028 Rule 1 among them) keeps its
// import path.

export {
  LEGACY_IDENTITY_ID_PATTERN,
  LEGACY_IDENTITY_ID_SUBSTRING_PATTERN,
  isLegacyIdentityId,
  legacyIdentityIdSchema,
  memberIdSchema,
} from '@galapagos/product-analytics';
